import React from 'react';
import styled from 'styled-components';
import './css/Kicks.css';

import Kick from '../kick/Kick'

const Paragragh = styled.p`
  font-size: 2em;
  line-height: initial;
  padding: .5em;
`;

var yeezyLinks = [
  {text:"Addidas.com", link:"https://www.adidas.com/us/yeezy"},
  {text:"Bodega", link:"https://bdgastore.com/blogs/upcoming-releases/7-13-19-adidas-yeezy-boost-350-v2#SR"},
  {text:"Extra Butter", link:"https://shop.extrabutterny.com/collections/release-draws/products/adidas-yeezy-boost-350-v2-lundmark-fu9161?variant=29063704903728#SR"},
  {text:"Hibbet Sports", link:"https://www.hibbett.com/adidas-yeezy-350-v2-lundmark-mens-shoe/M0972.html?dwvar_M0972_color=0001&cgid=launch-calendar#prefn1=dtLaunch&sz=24&start=45&prefv1=30#SR"},
  {text:"SNS", link:"https://www.sneakersnstuff.com/en/product/39305/adidas-yeezy-boost-350-v2#SR"},
  {text:"YCMC", link:"https://www.ycmc.com/yeezy-raffle#SR"}
]

const Kicks = (props) => {

  return (
    <div>
      <div className="container-fluid full-bg-image">
        <div className="row bg-gradient">
          <div className="col text-center">
            <div className="heading-text">The Sneaker Raffle</div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row justify-content-center"> 
          <Paragragh>Your source for all the latest sneaker raffle info:</Paragragh>
        </div>
        <div className="row pb-5">
          <Kick name="YEEZY BOOST 350 V2" info={yeezyLinks} image="yeezy350v2.jpg" price="$220" date="July 11th" colorway="LUNDMARK" />
        </div>
      </div>
    </div>
  )
}

export default Kicks;
